export const lineColors: any = {
  0: { color: '#c94949' },
  1: { color: '#1272d1' },
  2: { color: '#922fc1' },
  3: { color: '#e79924' },
  4: { color: '#63b420' },
  5: { color: '#24397a' },
  6: { color: '#f9237a' },
  7: { color: '#14e6b4' },
  8: { color: '#a3a879' },
  9: { color: '#e29f91' },
  10: { color: '#166d3c' },
  11: { color: '#6caba0' },
  12: { color: '#15a2b9' },
  13: { color: '#574d36' },
  14: { color: '#9185d7' },
}
const axisMarkingStyle = {
  fontSize: 12,
  color: '#707070',
}
export const chartOptions = {
  chartArea: { left: 70, bottom: 70, top: 30, right: 30 },
  legend: { position: 'none' },
  series: lineColors,
  //explorer: { axis: 'horizontal', keepInBounds: true },
  hAxis: {
    textStyle: axisMarkingStyle,
    baselineColor: '#d6d6d6',
    gridlines: {
      color: '#FFF',

      units: {
        days: { format: ['HH:mm \n MMM dd '] },
        hours: { format: ['HH:mm', 'HH'] },
      },
    },
    minorGridlines: {
      units: {
        hours: { format: ['HH:mm'] },
      },
    },
    maxAlternation: 1,
  },
  isStacked: true,
  bar: { groupWidth: 25 },
  vAxis: {
    //format: "%",
    minValue: 0,
    maxValue: 100,
    viewWindow: { min: 0 },
    ticks: [0, 1],
    gridlines: {
      color: '#FFF',
    },
    textStyle: axisMarkingStyle,
    baselineColor: '#d6d6d6',
  },
  lineWidth: 1.5,
  tooltip: { isHtml: true, trigger: 'both' },
  crosshair: {
    trigger: 'focus',
    orientation: 'vertical',
  },
}
